module.exports = __webpack_public_path__ + "img/ehr.30b0808c.svg";